import { createContext } from 'react';

export const visibleIndexesRefContext = createContext<[React.MutableRefObject<number>, React.MutableRefObject<number>]>(
  [
    { current: 0 },
    { current: 0 },
  ],
);
